import React, { Component } from 'react';

import IconButton from 'material-ui/IconButton';
import Iframe from '../Iframe';
import Popover from 'material-ui/Popover';

class AppMenu extends Component {

    constructor(props) {
        super(props);
        this.state = { open: false, anchorEl: undefined };
    }

    handleClick(event) {
        if (!this.state.open) {
            this.setState({ open: true, anchorEl: event.currentTarget });
        } else {
            const el = document.getElementById('apps-widget-popover');
            el.style.display = 'block';
        }
    };

    handleRequestClose() {
        const el = document.getElementById('apps-widget-popover');
        el.style.display = 'none';
    };

    getComponent() {

        if (this.state.open) {
            return (
                <Popover
                    id="apps-widget-popover"
                    className="apps-widget-popover"
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    onRequestClose={this.handleRequestClose.bind(this)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                >
                    <Iframe
                        style={{width: '300px'}}
                        src={`${process.env.REACT_APP_WIDGETS}/apps/`} />
                </Popover>
            )
        }

        return null;
    }

    render() {
        return (
            <div>
                <IconButton color="inherit" onClick={this.handleClick.bind(this)}>
                    <i className="material-icons">apps</i>
                </IconButton>

                {this.getComponent()}
            </div>
        );
    }
}

export default AppMenu;



// WEBPACK FOOTER //
// ./src/psuite-js/components/mui/AppMenu.js